import React, { useEffect, useState } from 'react';
import ClassTalkMassages from '../classtalk/ClassTalkMessages';
import EmoticItem from '../classtalk/emoticon/EmoticItem';
import EmoticList from '../classtalk/emoticon/EmoticList';
import AudioRecord from '../classtalk/voiceMemo/AudioRecord';
import InputGroupBoxInLive from '../classtalk/InputGroupBoxInLive';
import FunctionList from '../classtalk/FunctionList';
import WebWhisper from "../classtalk/WebWhisper";

const ClassTalkLive = ({ classTalkVisibility, web_isWhisper, openInfo, isLiveChattingLocked, handsUpYN, myHandsUpYN, connectStatus, classTalkMsg, isProgressBarShow, progressCount, isConnectedOnScreenApp, handleSelectedClassTalkFunc }) => {
    const [isShow, setIsShow] = useState(isProgressBarShow);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        setProgress(progressCount);
    }, [progressCount]);

    useEffect(() => {
        setIsShow(isProgressBarShow);
    }, [isProgressBarShow]);

    return (
        // 20261015 학생 클래스톡 말풍선 모양 통일을 위한 화면 구분 클래스(ct-live-screen) 추가
        <div className="d-flex flex-column white ct-live-screen" style={{ minHeight: '50%', height: '100%', overflow: 'hidden' }}>
            <div className="progress-container" style={{ display: isShow ? "flex" : "none" }}>
                <div id="pentalk-browser-progressbar" className="progress-fill" style={{ width: `${progress}%` }}>
                    {progress} %
                </div>
            </div>
            <ClassTalkMassages
                classTalkVisibility={classTalkVisibility}
                classTalkMsg={classTalkMsg}
                handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
            />
            {
                openInfo.selectedEmoticonSeq > -1 &&
                <EmoticItem
                    selIndex={openInfo.selectedEmoticonSeq}
                    handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
                />
            }
            {
                openInfo.isEmoticonSelected &&
                <EmoticList handleSelectedClassTalkFunc={handleSelectedClassTalkFunc} />
            }
            <WebWhisper
                web_isWhisper={web_isWhisper}
                classTalkVisibility={classTalkVisibility}
                isAddFunctionOpened={openInfo.isAddFunctionOpened}
                handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
            />
            {
                openInfo.isAudioOpened ?
                    <AudioRecord
                        onHandleClassTalkFunc={handleSelectedClassTalkFunc}
                        handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
                    /> :
                    <InputGroupBoxInLive
                        classTalkVisibility={classTalkVisibility}
                        isLiveChattingLocked={isLiveChattingLocked}
                        web_isWhisper={web_isWhisper}
                        isAddFunctionOpened={openInfo.isAddFunctionOpened}
                        selIndex={openInfo.selectedEmoticonSeq}
                        onHandleClassTalkFunc={handleSelectedClassTalkFunc}
                        handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
                    />
            }
            {
                openInfo.isAddFunctionOpened &&
                <FunctionList
                    isChatting={false}
                    web_isWhisper={web_isWhisper}
                    handsUpYN={handsUpYN}
                    myHandsUpYN={myHandsUpYN}
                    connectStatus={connectStatus}
                    onHandleClassTalkFunc={handleSelectedClassTalkFunc}
                    handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
                    isConnectedOnScreenApp={isConnectedOnScreenApp}
                />
            }
        </div>
    );
}
export default ClassTalkLive;
